// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.addWidget_iNu2w {
  width : 100%;
  height : 100%;
  display : flex;
  align-items : center;
  justify-content: center;
  min-height : 100px;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-dashboard/lib/editor/GridEditor.css"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;AACpB","sourcesContent":["\n.addWidget {\n  width : 100%;\n  height : 100%;\n  display : flex;\n  align-items : center;\n  justify-content: center;\n  min-height : 100px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addWidget": `addWidget_iNu2w`
};
export default ___CSS_LOADER_EXPORT___;
